module.exports = __webpack_public_path__ + "static/media/investopedia.2164f4f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/page/home/media/images/investopedia.png
// module id = 1795
// module chunks = 146